import { Injectable, Renderer2 } from '@angular/core';
import { InformationNoteComponent } from '../information-note/information-note.component';
import { DocumentInformationNoteModel } from '../../model/information-note';
import { NativeWindowService } from '../../service/native-window.service';
import { ConnectedDocumentService } from '../../../rent/service/data/connected-document-base.service';
import { DocumentConnectionBase } from '../../../common/model/document-connection-base';

@Injectable()
export abstract class DocumentInformationNoteComponent<
  TModel extends DocumentConnectionBase,
> extends InformationNoteComponent<DocumentInformationNoteModel> {
  constructor(
    _renderer: Renderer2,
    private documentService: ConnectedDocumentService<TModel>,
    private nativeWindow: NativeWindowService
  ) {
    super(_renderer);
  }

  click(event: MouseEvent, item: DocumentInformationNoteModel) {
    event.stopPropagation();
    const model = this.documentService.createModel();
    model.id = item.documentId;
    this.documentService.download(model).subscribe(result => this.nativeWindow.save(result));
  }
}
